<!--
  Standing behind the desk, with the hands resting on it: only the edge of the desk in the picture is hidden behind it.
  Everything turns and scales around the bottom, so the presenter stays put on the desk instead of floating.
-->
<div
  class="relative -mb-5 h-96 w-full origin-bottom transition-[translate,rotate,scale,filter] duration-700 ease-in-out"
  [class]="poseClass()"
  [class.scale-120]="enlarged()"
>
  <!-- Breathing, all the time, so it never has to stop or jump when the mood changes -->
  <div class="anim-heave size-full origin-bottom motion-reduce:animate-none">
    <div class="relative size-full origin-bottom" [class]="swapClass()">
      <!-- All sprites are there, so swapping between them never waits for an image -->
      @for (s of SPRITES; track s) {
        <img
          class="absolute inset-0 size-full object-contain object-bottom select-none"
          alt=""
          draggable="false"
          [src]="'/lingo/presenter-' + s + '.webp'"
          [class.invisible]="s !== sprite()"
        />
      }
    </div>
  </div>
</div>

<!-- The desk, with the sign on the front, casting a bit of shadow on the presenter behind it -->
<div class="relative flex w-240 flex-col items-center rounded-[36px] shadow-[0_-10px_24px_rgb(0_0_0/0.35)]">
  <rid-lingo-marquee class="w-full rounded-[36px]! p-7!" [mood]="deskMood()" [bulbSpacing]="48">
    <div
      class="grid place-items-center rounded-2xl bg-linear-to-b from-[#1a3f9e] to-[#0f2a6e] px-6 py-2 shadow-[inset_0_6px_16px_rgb(0_0_0/0.4)]"
    >
      <rid-lingo-title class="text-[5.5rem]!" [mood]="titleMood()" />
    </div>
  </rid-lingo-marquee>
</div>
